import { useEffect, useRef } from "react";
import { makeStyles } from "tss-react/mui";
import { MiButton } from "@miplatform/components";
import { Box } from "@mui/system";

export const MiWorkBoardItem = ({
  children,
  onClick,
  className,
  showHighlight = false,
}: {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  showHighlight?: boolean;
}) => {
  const { classes } = useStyles();

  const itemRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (showHighlight && itemRef.current) {
      itemRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  }, [showHighlight]);

  if (onClick) {
    return (
      <MiButton
        className={`${classes.workBoardItemContainer} ${className} ${
          showHighlight ? classes.workBoardItemHighlight : ""
        }`}
        onClick={onClick}
        ref={itemRef}
      >
        {children}
      </MiButton>
    );
  }

  return <Box className={classes.workBoardItemContainer}>{children}</Box>;
};

const useStyles = makeStyles()((theme) => ({
  workBoardItemContainer: {
    width: "100%",
    minWidth: 130,
    flex: 1,
    overflow: "hidden",
    textAlign: "left",
    padding: 0,
  },
  workBoardItemHighlight: {
    boxShadow: `0 0 5px 2px ${theme.palette.info.main}`,
  },
}));
